import { Helmet } from 'react-helmet-async';
import '../../assets/styles/CRM.css'
import crmDashboardImg from "../../assets/images/frontend.jpeg";
import crmAnalyticsImg from "../../assets/images/backend.png";
import crmAutomationImg from "../../assets/images/fullstackdeveloper.png";
import crmIntegrationImg from "../../assets/images/ecommercedevelopment.jpg";
import crmMobileImg from "../../assets/images/mobileappdevelopment.png";

const CRM = () => {

  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> CRM Software – BuddyTech Solutions </title>
        <meta name="description" content="Customer relationship management tool to streamline communication and sales." />
        <meta name="keywords" content="CRM software, CRM platform" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="CRM Software – BuddyTech Solutions" />
        <meta property="og:description" content="Customer relationship management tool to streamline communication and sales." />
        <meta property="og:keywords" content="CRM software, CRM platform" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/products/crm" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="CRM Software – BuddyTech Solutions" />
        <meta name="twitter:description" content="Customer relationship management tool to streamline communication and sales." />
        <meta name="twitter:keywords" content="CRM software, CRM platform" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="crm-container">
        <header className="crm-hero">
          <h1>Customer Relationship Management (CRM)</h1>
          <p>Empower your sales, marketing, and support teams with a powerful and intuitive CRM platform.</p>
        </header>

        <section className="crm-overview">
          <div className="crm-overview-text">
            <h2>Why Choose Our CRM?</h2>
            <p>
              Our CRM solution offers a centralized platform to manage customer interactions, automate workflows, track leads, and analyze customer data to improve relationships and drive growth.
            </p>
            <ul>
              <li>Lead and pipeline management</li>
              <li>Sales automation & forecasting</li>
              <li>Email campaigns & contact segmentation</li>
              <li>Advanced analytics & reporting</li>
              <li>Omnichannel integration (email, calls, social)</li>
            </ul>
          </div>
          <img src={crmDashboardImg} alt="CRM Dashboard" className="crm-overview-img" />
        </section>

        <section className="crm-features">
          <h2>Key Features</h2>
          <div className="crm-feature-grid">
            <div className="crm-feature-card">
              <img src={crmAnalyticsImg} alt="CRM Analytics" />
              <h3>Real-Time Analytics</h3>
              <p>Get insights into customer behavior and team performance with live dashboards and reports.</p>
            </div>

            <div className="crm-feature-card">
              <img src={crmAutomationImg} alt="CRM Automation" />
              <h3>Workflow Automation</h3>
              <p>Automate repetitive tasks like follow-ups, task assignments, and email triggers.</p>
            </div>

            <div className="crm-feature-card">
              <img src={crmIntegrationImg} alt="CRM Integrations" />
              <h3>Third-party Integrations</h3>
              <p>Connect with tools like Mailchimp, Slack, Zoom, and more to extend CRM capabilities.</p>
            </div>

            <div className="crm-feature-card">
              <img src={crmMobileImg} alt="CRM Mobile Access" />
              <h3>Mobile Access</h3>
              <p>Manage customer relationships from anywhere using responsive mobile interfaces and apps.</p>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default CRM
